export const ROUTES = {
    HOME: "/",
    LOGIN: "/login",
};
